import { loadTossPayments, ANONYMOUS } from '@tosspayments/tosspayments-sdk';

export { ANONYMOUS };

const TOSS_CLIENT_KEY = process.env.NEXT_PUBLIC_TOSS_CLIENT_KEY!;

export async function initTossWidgets(customerKey: string = ANONYMOUS) {
  const tossPayments = await loadTossPayments(TOSS_CLIENT_KEY);
  const widgets = tossPayments.widgets({ customerKey });
  return widgets;
}
